//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getSplitRightsOwnedOrPendingMedia } from '@galleries/selectors/bulk-rights-selectors/getSplitRightsOwnedOrPendingMedia';

export const getIsRightsOwnedOnAllMedia = createSelector(
  getSplitRightsOwnedOrPendingMedia,
  ({ rightsNotOwnedItems }) => rightsNotOwnedItems.length === 0,
);
